import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import Cached from '@mui/icons-material/Cached';
import CircularProgress from '@mui/material/CircularProgress';

interface RefreshButtonProps {
  loading: boolean;
  onClick: () => void;
}

const RefreshButton = ({ loading, onClick }: RefreshButtonProps) => {
  const tooltipCopy = 'Refresh ArcGIS Layers';

  return (
    <Box
      display="flex"
      paddingLeft="6px"
      paddingTop="2px"
    >
      { loading ? (
        <Box paddingLeft="9px">
          <CircularProgress color="secondary" size={18} />
        </Box>
      ) : (
        <Tooltip
          title={tooltipCopy}
          arrow
          placement="top"
          data-testid="mui-tooltip"
        >
          <Button
            sx={{ '&:hover': { backgroundColor: 'transparent', boxShadow: 'none' } }}
            onClick={onClick}
          >
            <Cached fontSize="small" color="secondary" />
          </Button>
        </Tooltip>
      )}
    </Box>
  );
};

export default RefreshButton;
